import * as options from '@vuedir/constants/options';
import { products } from '@canvaspop/scoops';
export function getPanels(productSlug) {
    return productSlug ? products.PANELS[productSlug] : 1;
}
export function getSelectedWidth(size, productSlug) {
    return size ? parseInt(size.split('|')[0], 10) * (productSlug === 'T' ? 3 : 1) : 0;
}
export function getSelectedHeight(size) {
    return size ? parseInt(size.split('|')[1], 10) : 0;
}
export function getEdgeDimension(productSlug, frame, customEdge) {
    var _a, _b;
    return customEdge ? customEdge : (((_b = (_a = products.DIMENSIONS[productSlug]) === null || _a === void 0 ? void 0 : _a[frame]) === null || _b === void 0 ? void 0 : _b.edge) || 0);
}
export function getFrame(productOptions) {
    return productOptions[options.OPTION_FRAME];
}
export function getEdge(productOptions) {
    return productOptions[options.OPTION_EDGE];
}
export function getBorder(productOptions) {
    return productOptions[options.OPTION_BORDER];
}
export function getBorderColor(productOptions) {
    return productOptions[options.OPTION_BORDER_COLOR];
}
export function getFilter(productOptions) {
    return productOptions[options.OPTION_FILTER];
}
export function getService(productOptions) {
    return productOptions[options.OPTION_SERVICE];
}
export function getEdgeColor(productSlug, edge) {
    var _a, _b;
    return ((_b = (_a = products.COLORS[productSlug]) === null || _a === void 0 ? void 0 : _a[edge]) === null || _b === void 0 ? void 0 : _b.color) || '';
}
export function getFrameDimension(productSlug, frame) {
    var _a, _b;
    return ((_b = (_a = products.DIMENSIONS[productSlug]) === null || _a === void 0 ? void 0 : _a[frame]) === null || _b === void 0 ? void 0 : _b.frame) || 0;
}
export function getGapDimension(productSlug, frame) {
    var _a, _b;
    return productSlug && frame && products.DIMENSIONS[productSlug] ? (_b = (_a = products.DIMENSIONS[productSlug]) === null || _a === void 0 ? void 0 : _a[frame]) === null || _b === void 0 ? void 0 : _b.gap : 0;
}
export function getMatDimension(productSlug, edge) {
    var _a, _b;
    return ((_b = (_a = products.DIMENSIONS[productSlug]) === null || _a === void 0 ? void 0 : _a[edge]) === null || _b === void 0 ? void 0 : _b.mat) || 0;
}
export function getBorderDimension(productSlug, border) {
    var _a, _b;
    return ((_b = (_a = products.BORDERS[productSlug]) === null || _a === void 0 ? void 0 : _a[border]) === null || _b === void 0 ? void 0 : _b.size) || 0;
}
export function getBorderColorValue(productSlug, borderColor) {
    var _a, _b;
    return ((_b = (_a = products.BORDER_COLORS[productSlug]) === null || _a === void 0 ? void 0 : _a[borderColor]) === null || _b === void 0 ? void 0 : _b.color) || '';
}
export function getFrameColor(productSlug, frame) {
    var _a, _b;
    return ((_b = (_a = products.DIMENSIONS[productSlug]) === null || _a === void 0 ? void 0 : _a[frame]) === null || _b === void 0 ? void 0 : _b.color) || '';
}
export function getPanes() {
    const panes = [
        {
            'top': 0,
            'left': 0,
            'width': 100,
            'height': 100,
            'id': 'pane_1',
        },
    ];
    return panes;
}
export function getTotalWidth(width, edgeDimension) {
    return width + (2 * edgeDimension);
}
export function getTotalHeight(height, edgeDimension) {
    return height + (2 * edgeDimension);
}
export function getSizePrice(sizes, size) {
    var _a;
    if (sizes && size) {
        return ((_a = sizes[size]) === null || _a === void 0 ? void 0 : _a.foreignPrice) || 0;
    }
    else {
        return 0;
    }
}
export function getEdgePrice(sizes, size, edges, edge) {
    var _a, _b;
    if (sizes && edges && size && edge) {
        return ((_b = (_a = sizes[size]) === null || _a === void 0 ? void 0 : _a.edges[edge]) === null || _b === void 0 ? void 0 : _b.foreignPrice) || 0;
    }
    else {
        return 0;
    }
}
export function getFramePrice(sizes, size, frames, frame) {
    var _a, _b;
    if (sizes && frames && size && frame) {
        return ((_b = (_a = sizes[size]) === null || _a === void 0 ? void 0 : _a.frames[frame]) === null || _b === void 0 ? void 0 : _b.foreignPrice) || 0;
    }
    else {
        return 0;
    }
}
export function getFilterPrice(sizes, filters, filter) {
    var _a;
    if (sizes && filters && filter) {
        return ((_a = filters[filter]) === null || _a === void 0 ? void 0 : _a.foreignPrice) || 0;
    }
    else {
        return 0;
    }
}
export function getServicePrice(sizes, services, service) {
    var _a;
    if (sizes && services && service) {
        return ((_a = services[service]) === null || _a === void 0 ? void 0 : _a.foreignPrice) || 0;
    }
    else {
        return 0;
    }
}
export function getTotalPrice(sizePrice, edgePrice, framePrice, filterPrice, servicePrice) {
    return sizePrice + edgePrice + framePrice + filterPrice + servicePrice;
}
